import {
    getIsApiPending,
    getAccessToken,
    getPaymentsForm,
    getStkData,
    getStatusApiCallStatus,
    getPaymentMode,
    getPaymentStatusData,
    getIsStatusAPiPending
} from '../../../selectors/personalPensionPlan/payments';
import { getQuoteForm } from '../../../selectors/personalPensionPlan/quote';

import {
    apiTransitionStkPush,
    apiTransitionPaymentsStatus,
    triggerPaymentsStkPushSuccess,
    triggerPaymentsStkPushFailure,
    checkPaymentsStatusSuccess,
    checkPaymentsStatus,
} from '../../../actions/personalPensionPlan/payments';
import axios from 'axios';
import { getIsApiPaymentStatusPending } from '../../../selectors/roaCarInsurance/payments';
import { setExpiredAuth } from '../../../actions/personalPensionPlan/quote';
import { collectPayloadData } from '../../../actions/personalPensionPlan/payloadCollection';
import { getCustomerIdValue } from '../../../selectors/personalPensionPlan/personalDetails';
import {
    apiTransitionPayloadCollection,
    submitPayloadDataSuccess,
    submitPayloadDataFailure,
} from '../../../actions/personalPensionPlan/payloadCollection';
import { getIsLumpsumPrepaidValue, getPremiumCalculation } from '../../../selectors/personalPensionPlan/quote';
import {
    triggerConfirmOrder,
    setBankDetailsSuccess,
    setPrepaidSubmitSuccess,
} from '../../../actions/personalPensionPlan/payments';

let intervalId = null;
const clearIntervalId = (intervalId) => {
    clearInterval(intervalId);
    intervalId = null;
};

const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;

export const paymentsStkService = (store, next, action) => {
    const result = next(action);
    const state = store.getState();
    (async () => {
        if (!getIsApiPending(state)) {
            store.dispatch(apiTransitionStkPush.pending());
        
            try {
                const resp = await makeStkPaymentSubmission(state);
                store.dispatch(triggerPaymentsStkPushSuccess(resp.data));

                setTimeout(() => {
                    store.dispatch(apiTransitionStkPush.success());
                }, 3000);
                
                // setTimeout(() => {
                //     store.dispatch(checkPaymentsStatus());
                // }, 10000);
                
                // intervalId = setInterval(() => {
                //     store.dispatch(checkPaymentsStatus());
                //     if (getStatusApiCallStatus(state) === 'success') {
                //         clearIntervalId(intervalId);
                //     }
                // }, 15000);
                // setTimeout(() => {
                //     if (intervalId) {
                //         clearIntervalId(intervalId);
                //         store.dispatch(apiTransitionPaymentsStatus.failure());
                //     }
                // }, 90000);

                intervalId = setInterval(() => {
                    store.dispatch(checkPaymentsStatus());

                    if (getStatusApiCallStatus(state) === 'success') {
                        clearIntervalId(intervalId);
                    }
                }, 5000);
                setTimeout(() => {
                    if (intervalId) {
                        clearIntervalId(intervalId);
                        store.dispatch(apiTransitionPaymentsStatus.failure());
                        // store.dispatch(collectPayloadData());
                        return;
                    }
                }, 60000);
            } catch (e) {
                store.dispatch(apiTransitionStkPush.failure());
                //store.dispatch(triggerPaymentsStkPushFailure(e.response));
                clearIntervalId(intervalId);
                return e;
            }
        }
    })();
    return result;
};

// ----------- stk push on backend -----------
const newPayloadCollection = (state) => {
    const id = getCustomerIdValue(state)
    const quotation = getQuoteForm(state);
    const paymentMode = getPaymentMode(state);
    const premium =
        quotation?.contributionMode?.value === 'monthly-contribution-only'
            ? quotation?.desiredMonthlyContribution?.value
            : quotation?.lumpsumAmount?.value;
    const paymentsData = getPaymentsForm(state);
    const msisdn = formatPhoneNumber(paymentsData.phoneNumber.value, '254');
    
    const payload = {
        pension_id: id.value,
        countryCode: 'KE',
        mpesaPaymentNumber: msisdn,
        modeOfPayment: paymentMode === 'Mpesa' ? 'Mpesa' : 'Bank',
        paidAmount: premium
    }

    return {
        ...payload
    }
};

function getCurrentTimestamp() {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const timestamp = `${day}${month}${year}${hours}${minutes}${seconds}`;
    return timestamp;
}

function formatPhoneNumber(phoneNumber, countryCode) {
    const cleanedNumber = phoneNumber.substring(1);
    const formattedNumber = `${countryCode}${cleanedNumber}`;

    return formattedNumber;
}

const makeStkPaymentSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/personal-pension-plan/payment';
        return await axios.post(url, newPayloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
// --------------- end -----------


// ----------- check payment -----------
const stkCheckPaymentPayload = (state) => {
    const stkData = getStkData(state);
    
    const payload = {
        checkout_request_id: stkData.data.checkoutRequestId || null,
        id: stkData.data.pension_id
    };
    return {
        ...payload,
    };
};

const makeCheckPaymentSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/personal-pension-plan/check-payment';
        return await axios.post(url, stkCheckPaymentPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};

export const CheckPaymentsStkStatusService = (store, next, action) => {
    const result = next(action);
    const state = store.getState();
    (async () => {
        if (getStatusApiCallStatus(state) === 'success') {
            clearIntervalId(intervalId);
            return;
        }
        if (!getIsStatusAPiPending(state)) {
            store.dispatch(apiTransitionPaymentsStatus.pending());
            try {
                if (getStatusApiCallStatus(state) !== 'success') {
                    const resp = await makeCheckPaymentSubmission(state);
                    if (resp.data && resp.data.success) {
                        clearIntervalId(intervalId);
                        intervalId = null;
                        store.dispatch(checkPaymentsStatusSuccess(resp.data));
                        store.dispatch(apiTransitionPaymentsStatus.success());
                        return;
                    }
                } else {
                    return;
                }
            } catch (e) {
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                }

                if(e?.response?.data?.status === 400 || e?.response?.data?.status === 408) {
                    store.dispatch(apiTransitionPaymentsStatus.failure());
                    clearIntervalId(intervalId);
                    intervalId = null;
                }

                intervalId = null;
                store.dispatch(apiTransitionPaymentsStatus.failure());
                //store.dispatch(checkPaymentsStatusFailure(e.response));
                return e;
            }
        }
    })();
    return result;
};

// --------------- end -----------

const stkPushPayload = (state) => {
    const paymentsData = getPaymentsForm(state);

    const quotation = getQuoteForm(state);

    const premium =
        quotation?.contributionMode?.value === 'monthly-contribution-only'
            ? quotation?.desiredMonthlyContribution?.value
            : quotation?.lumpsumAmount?.value;

    const requestId = getCurrentTimestamp();
    const msisdn = formatPhoneNumber(paymentsData.phoneNumber.value, '254');

    const payload = {
        msisdn: msisdn,
        amount: premium.toString(),
        description: 'Personal Pension Plan',
        accountReference: requestId,
        type: 'PERSONAL_PENSION_PLAN',
    };

    return {
        ...payload,
    };
};

const triggerStkPush = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/payments/stk';
        return await axios.post(url, stkPushPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                Cookie: 'devEnvironment=ea-qa',
            },
        });
    } catch (e) {
        if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
            store.dispatch(setExpiredAuth(true));
        }
        store.dispatch(triggerPaymentsStkPushFailure(e?.response?.data || {}));
        throw e;
    }
};

export const paymentsStkStatusService = (store, next, action) => {
    const result = next(action);
    const state = store.getState();
    (async () => {
        if (getStatusApiCallStatus(state) === 'success') {
            clearIntervalId(intervalId);
            return;
        }
        if (!getIsApiPaymentStatusPending(state)) {
            store.dispatch(apiTransitionPaymentsStatus.pending());
            try {
                const resp = await triggerStkStatusCheck(state);
                if (resp.data && resp.data.success) {
                    clearIntervalId(intervalId);
                    intervalId = null;
                    store.dispatch(checkPaymentsStatusSuccess(resp.data));
                    store.dispatch(apiTransitionPaymentsStatus.success());
                    return;
                }
            } catch (e) {
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                }
                //store.dispatch(apiTransitionPaymentsStatus.failure());
                console.error(e.response);
                //store.dispatch(checkPaymentsStatusFailure(e.response));
                return e;
            }
        }
    })();
    return result;
};

const stkStatusPayload = (state) => {
    const stkData = getStkData(state);
    const payload = {
        checkout_request_id: stkData.data.CheckoutRequestID || null,
    };
    return {
        ...payload,
    };
};

const triggerStkStatusCheck = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/payments/stk/status';
        return await axios.post(url, stkStatusPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                Cookie: 'devEnvironment=ea-qa',
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};


// add payment service
export const payloadPaymentsService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPayloadCollection.pending());
            try {
                await makePaymentSubmission(store.getState());
                store.dispatch(apiTransitionPayloadCollection.success());

                const isPrepaidLumpsum = getIsLumpsumPrepaidValue(store.getState());
                
                if (isPrepaidLumpsum?.value === 'yes') {
                    store.dispatch(setPrepaidSubmitSuccess(true));
                    store.dispatch(triggerConfirmOrder());
                } else {
                    const modeOfPayment = getPaymentMode(store.getState());

                    if (modeOfPayment === 'Mpesa') {
                        store.dispatch(triggerConfirmOrder());
                    } else {
                        store.dispatch(setBankDetailsSuccess(true));
                    }
                }

            } catch (e) {
                store.dispatch(submitPayloadDataFailure(e));
                store.dispatch(apiTransitionPayloadCollection.failure());
            }
        }
    })();
    return next(action);
}

const payloadCollection = (state) => { 

    const modeOfPayment = getPaymentMode(state);
    const paymentsData = getPaymentStatusData(state);
    const quotation = getQuoteForm(state);
    const pid = getCustomerIdValue(state)

    const paidAmount =
        quotation?.contributionMode?.value === 'monthly-contribution-only'
            ? quotation?.desiredMonthlyContribution?.value
            : quotation?.lumpsumAmount?.value;

    const payload = {
        pension_id: pid.value,
        countryCode: gatsbyStack.toUpperCase(),
        modeOfPayment: modeOfPayment,
        paidAmount: paidAmount,
        mpesaPaymentNumber:
            quotation.isLumpsumPrepaid?.value === 'yes'
                ? quotation.prepaidTransactionCode?.value
                    ? quotation.prepaidTransactionCode?.value
                    : 'N/A'
                : modeOfPayment === 'Mpesa'
                ? paymentsData?.CheckoutRequestID
                    ? paymentsData?.CheckoutRequestID
                    : 'N/A'
                : 'N/A',
    }

    return {
        ...payload
    }
}

const makePaymentSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/personal-pension-plan/payment';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};


